import { cloneDeep, get } from 'lodash';
import customFunc from '@/util/util';

const bzfaCluseCode = 'GP8032649454345';
const highSkyClauseCode = 'GP8032614187291';
const plusOptionValue = '784138';

/**
 * 80326 意外医疗保险金不投保，则拓展自费药不可见且不可保
 * @param {*} clauses
 * @returns
 */
export const filterClauses80326 = (clauses) => {
  // 意外伤害医疗保险金
  const ywshylbxjClauseCode = 'GP8032664128466';
  // 拓展自费药
  const tzzfyClauseCode = 'GP8032663762961';
  const cloneClauses = cloneDeep(clauses);
  const ywshylbxjClause = cloneClauses.find((clause) => clause.clauseCode === ywshylbxjClauseCode);
  // 若意外医疗不投保，则拓展自费药置为否且隐藏
  const tzzfyClause = cloneClauses.find((clause) => clause.clauseCode === tzzfyClauseCode);

  if (ywshylbxjClause.selected.value == 0) {
    tzzfyClause.selected = tzzfyClause.optionList.find(
      (option) => option.value === '267089' || option.showValue === '否'
    );
    tzzfyClause.hidden = true;
  } else {
    delete tzzfyClause.hidden;
  }
  return cloneClauses;
};

/**
 * 80326 校验1-3类职业不可选PLUS
 * @param {*} orderClauseList
 * @param {*} profession - 职业
 * @param {*} productId
 * @param {*} isQuotePage - 报价页可以只选职业大类，所以对报价页职业细类code不做校验
 */
export const validatePlus80326 = ({ orderClauseList, profession, productId, isQuotePage }) => {
  if (productId + '' !== '80326') return '';
  const clauseCode = 'GP8032649454345';
  const clause = orderClauseList.find((item) => item.clauseCode === clauseCode);
  const isPlus = clause?.selected?.value == plusOptionValue;
  if (!isPlus) {
    return '';
  }
  // 因为不选择职业的时候默认会填充1，所以做下code的判断，但是报价页可以选职业大类的，所以对报价页这个code不做校验
  if (!profession.val || (!isQuotePage && !profession.code)) {
    return '';
  }
  if (+profession.val >= 1 && +profession.val <= 3) {
    return '1-3类职业，不可选PLUS';
  }
  return '';
};

// 80326 校验1-3类职业不可选PLUS - 对每个计划的校验
export const validatePlus80326ForSchemes = ({
  schemes,
  orderClauseList,
  isQuotePage,
  productId,
}) => {
  if (productId + '' !== '80326') {
    return '';
  }
  for (let i = 0; i < schemes.length; i++) {
    const scheme = schemes[i];
    const singleSchemeValidateMsg = validatePlus80326ForSingleScheme({
      currentScheme: scheme,
      orderClauseList,
      productId,
    });
    if (singleSchemeValidateMsg) {
      return `${singleSchemeValidateMsg}，请修改计划${customFunc.numberToChinese(
        i + 1
      )}中的责任选项，或取消PLUS`;
    }
    let professions = scheme.professions;
    if (isQuotePage) {
      professions = scheme.professionList;
    }
    for (let j = 0; j < professions?.length; j++) {
      const profession = isQuotePage ? professions[j].professions : professions[j];
      const errMsg = validatePlus80326({
        orderClauseList,
        profession,
        productId,
        isQuotePage,
      });
      if (errMsg) {
        return `${errMsg}，请修改计划${customFunc.numberToChinese(i + 1)}中第${
          j + 1
        }个职业，或取消PLUS`;
      }
    }
  }
  return '';
};

// 80326 校验非高空不可选PLUS - 对单个计划的校验
export const validatePlus80326ForSingleScheme = ({ currentScheme, orderClauseList, productId }) => {
  if (productId + '' !== '80326') return '';
  if (!orderClauseList?.length) return '';
  const bzfaClause = orderClauseList.find((item) => item.clauseCode === bzfaCluseCode);
  const isPlus = bzfaClause?.selected?.value == plusOptionValue;
  if (!isPlus) return '';
  const highSkyClause = currentScheme.planClauseList.find(
    (clause) => clause.clauseCode === highSkyClauseCode
  );
  // 非高空不可选plus
  if (highSkyClause?.selected.value == '973900') {
    return `非高空不可选择PLUS`;
  }
  return '';
};

/**
 * 80326 校验多个计划中，至少有一个投保了“意外医疗保险金GP8032664128466”，保单维度才能投保“扩展自费药GP8032663762961”
 */
export const validateZfy80326 = ({ schemes, orderClauseList, productId }) => {
  if (productId + '' !== '80326') return '';
  if (!orderClauseList?.length) return '';
  const kzzfyClauseCode = 'GP8032663762961';
  // 扩展自费药
  const kzzfyClause = orderClauseList.find((item) => item.clauseCode === kzzfyClauseCode);
  if (!kzzfyClause || get(kzzfyClause, 'selected.value') !== '159060') return '';
  const hasYwshylbxj = schemes.some((scheme) => {
    const ywshylbxjClause = scheme.planClauseList.find(
      (clause) => clause.clauseCode === 'GP8032664128466'
    );
    return get(ywshylbxjClause, 'selected.value') != '0';
  });
  if (!hasYwshylbxj) {
    return '当前保障未投保“意外医疗保险金"，扩展自费药请选择“否”';
  }
  return '';
};

// 80326 计划维度需同时校验：1-3类职业/非高空不可选PLUS，以及扩展自费药依赖意外医疗保险金
export const validate80326ForSchemes = (args) =>
  validatePlus80326ForSchemes(args) || validateZfy80326(args);

// 80326 报价单，计划如果没投保意外伤害医疗保险金GP8032664128466，则扩展自费药不显示
export const filterKzzfyQuotationShow80326 = (showRowSchemeList) => {
  let flitedList = cloneDeep(showRowSchemeList);
  const ywshylbxjClause = showRowSchemeList.find(
    (clause) => clause.clauseCode === 'GP8032664128466'
  );
  // 如果没有投保意外伤害医疗保险金，则过滤掉扩展自费药
  if (!ywshylbxjClause || get(ywshylbxjClause, 'selected.value') === '0') {
    flitedList = flitedList.filter((scheme) => scheme.clauseCode !== 'GP8032663762961');
  }
  return flitedList;
};



// WEBPACK FOOTER //
// ./src/mixin/special/special-80326.js